import { ChangeDetectorRef, Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FeatureGuardFacade } from '../feature-guard.facade';
import { GuardedFeature } from '../feature-guard.types';

@Directive({
  selector: '[rtFeatureGuardElement]',
  standalone: true,
})
export class FeatureGuardElementDirective {
  @Input('rtFeatureGuardElement') public feature: GuardedFeature;

  private ngOnDestroy$ = new Subject<void>();

  constructor(
    public facade: FeatureGuardFacade,
    protected cdRef: ChangeDetectorRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) {}

  public ngOnInit() {
    this.facade
      .checkFeatureAvailability(this.feature)
      .pipe(takeUntil(this.ngOnDestroy$.asObservable()))
      .subscribe(enabled => {
        if (enabled) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
        this.cdRef.detectChanges();
      });
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
}
